import {TestIdProps} from 'shared/web';

import {ButtonProps} from '../Button/Button';
import {Status} from '../Status/Status';
import {useTranslationContext} from '../TranslationProvider/TranslationContext';

export type EmptyStatusAction = Pick<
  ButtonProps,
  'onClick' | 'title' | 'isDisabled' | 'leftIcon' | 'variant' | 'rightIcon'
>;

export interface EmptyStatusProps extends TestIdProps {
  headline?: string;
  subheadline?: string;
  variant?: 'general' | 'table' | 'image' | 'message' | 'person' | 'vehicle';
  action?: EmptyStatusAction;
}

export function EmptyStatus(props: EmptyStatusProps) {
  const t = useTranslationContext();

  return (
    <Status
      icon={icons[props.variant ?? 'general']}
      headline={props.headline ?? t(headlines[props.variant ?? 'general'])}
      subheadline={props.subheadline}
      action={props.action}
      data-testid={props['data-testid']}
    />
  );
}

const icons = {
  image: 'custom/no_images',
  message: 'custom/no_messages',
  person: 'custom/no_person',
  table: 'custom/no_table_data',
  general: 'custom/no_data',
  vehicle: 'maps/directions_car',
} as const;

const headlines = {
  general: 'general.labels.noData',
  table: 'general.labels.noTableData',
  image: 'general.labels.noImages',
  message: 'general.labels.noMessages',
  person: 'general.labels.noPerson',
  vehicle: 'general.labels.noVehicle',
} as const;
